import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from '../../design-system/primitives/index.js'
import { isNightOffMeal } from '../../utils/nightOff.js'
import './planner.css'

/**
 * Confirm replace vs swap when assigning onto an occupied night.
 */
export default function MoveMealConflictModal({
  open,
  movingMeal,
  stripDay,
  fromWeekStart = null,
  busy = false,
  onCancel,
  onReplace,
  onSwap,
}) {
  const canSwap = Boolean(
    movingMeal?.assignedTo && (
      stripDay?.meal?.recipeId || isNightOffMeal(stripDay?.meal)
    ),
  )
  const movingName = movingMeal?.name || 'This meal'
  const occupiedName = stripDay?.meal?.name || 'the meal already there'
  const dayLabel = stripDay?.dayKey
    ? String(stripDay.dayKey).charAt(0) + String(stripDay.dayKey).slice(1).toLowerCase()
    : 'that night'
  const crossWeek = Boolean(
    movingMeal?.assignedTo
    && stripDay?.weekStartDate
    && (
      (movingMeal.weekStartDate && stripDay.weekStartDate !== movingMeal.weekStartDate)
      || fromWeekStart && stripDay.weekStartDate !== fromWeekStart
    ),
  )

  return (
    <Modal
      open={open}
      onClose={() => {
        if (!busy) onCancel?.()
      }}
      titleId="move-meal-conflict-title"
      describedById="move-meal-conflict-description"
      contentClassName="pantry-confirm-panel planner-move-conflict-modal"
    >
      <ModalHeader>
        <h2 id="move-meal-conflict-title" className="pantry-confirm-title">
          {canSwap ? 'Night already planned' : 'Replace planned meal?'}
        </h2>
      </ModalHeader>
      <ModalBody>
        <p id="move-meal-conflict-description" className="pantry-confirm-description">
          {canSwap ? (
            <>
              <strong>{occupiedName}</strong>
              {' '}
              is already on
              {' '}
              {dayLabel}
              {crossWeek ? ' next week' : ''}
              .
              {' '}
              Swap with
              {' '}
              <strong>{movingName}</strong>
              , or replace and remove
              {' '}
              {occupiedName}
              ?
            </>
          ) : (
            <>
              Putting
              {' '}
              <strong>{movingName}</strong>
              {' '}
              on
              {' '}
              {dayLabel}
              {' '}
              will replace
              {' '}
              <strong>{occupiedName}</strong>
              .
            </>
          )}
        </p>
      </ModalBody>
      <ModalFooter>
        <div className="pantry-confirm-actions">
          <button
            type="button"
            className="pantry-confirm-cancel-btn"
            disabled={busy}
            onClick={() => onCancel?.()}
          >
            Cancel
          </button>
          {canSwap && (
            <button
              type="button"
              className="planner-btn btn-secondary"
              disabled={busy}
              onClick={() => onSwap?.()}
            >
              Swap
            </button>
          )}
          <button
            type="button"
            className="planner-btn btn-primary"
            disabled={busy}
            onClick={() => onReplace?.()}
          >
            {busy ? 'Updating…' : 'Replace'}
          </button>
        </div>
      </ModalFooter>
    </Modal>
  )
}
